import { memo } from 'react'
import classNames from 'classnames'
import { Card } from '@campgladiator/cgui-core.atoms.card'
import { Button } from '@campgladiator/cgui-core.atoms.button'
import { Paragraph } from '@campgladiator/cgui-core.atoms.typography'
import { useDeviceWidth } from '../../../../common/hooks'
import {
  LoginSignUpProps,
  setTextAndBtnSizeByWindowWidthReturnType,
} from '../../Login.d'
import configuration from '../../../../configuration'
import styles from './LoginSignUpPanel.module.scss'

const setTextAndBtnSizeByWindowWidth = (
  width: number,
): setTextAndBtnSizeByWindowWidthReturnType => {
  if (width >= 576) {
    return { textSize: 'default', btnSize: 'default' }
  }
  return { textSize: 'xsmall', btnSize: 'small' }
}

const LoginSignUpPanel = ({ className = '', ...props }: LoginSignUpProps) => {
  const deviceWidth = useDeviceWidth()

  return (
    <Card className={classNames(styles.content, className)} raised {...props}>
      <Paragraph
        weight="book"
        size={setTextAndBtnSizeByWindowWidth(deviceWidth).textSize}
      >
        Don’t have an account yet?
      </Paragraph>
      <Button
        emphasis="secondary"
        size={setTextAndBtnSizeByWindowWidth(deviceWidth).btnSize}
        onClick={() => window.open(configuration.pricingUrl, '_blank')}
      >
        Sign Up
      </Button>
    </Card>
  )
}

export default memo(LoginSignUpPanel)
